<!--
 * @Author: zhaowh zhaowh@example.com
 * @Date: 2023-09-15 16:59:21
 * @LastEditors: zhaowh zhaowh@example.com
 * @LastEditTime: 2023-09-20 09:05:06
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
      <div class="title">
        <el-form
          ref="filterForm"
          :inline="true"
          :model="filterForm"
          class="filter-form"
        >
          <el-form-item prop="productName">
            <el-input
              class="city-select"
              v-model="filterForm.productName"
              placeholder="贷款产品名称"
            ></el-input>
          </el-form-item>
          <el-form-item prop="bankName">
            <el-autocomplete
              v-model="filterForm.bankName"
              :fetch-suggestions="bankAssociate"
              placeholder="金融机构名称"
              label="name"
              value="value"
              value-key="name"
              :trigger-on-focus="false"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleFilter()">查询</el-button>
            <el-button
              type="primary"
              plain
              icon="el-icon-refresh-right"
              @click="handleReset('filterForm')"
            >
              清空
            </el-button>
          </el-form-item>
        </el-form>
        <span class="export" @click="handleToExport">导出</span>
      </div>
    </div>
    <div class="main">
      <!-- 列表 -->
      <el-table :data="tableData" style="width: 100%; margin-top: 10px">
        <el-table-column label="序号" width="80" align="center">
          <template slot-scope="scope">
            {{
              (pagination.currentPage - 1) * pagination.pageSize +
              (scope.$index + 1)
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="bankName"
          label="金融机构名称"
          min-width="15%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="businessOutlets"
          label="业务网点"
          min-width="15%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="productName"
          label="贷款产品名称"
          min-width="15%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="productType"
          label="产品类型"
          min-width="15%"
          align="center"
          :formatter="formatProductType"
        >
        </el-table-column>
        <el-table-column
          prop="minYearRate"
          label="年利率"
          min-width="10%"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.minYearRate ? `${row.minYearRate}%起` : '' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="maxLoanLimit"
          label="最高可贷"
          min-width="10%"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.maxLoanLimit ? `${row.maxLoanLimit}万` : '' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="maxLoanTerm"
          label="最长可贷"
          min-width="10%"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.maxLoanTerm ? `${row.maxLoanTerm}个月` : '' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="10%" align="center">
          <template slot-scope="{ row }">
            <el-button
              type="primary"
              plain
              round
              size="small"
              @click="handleToDetail(row)"
              >查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,prev, pager, next,jumper"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </el-main>
</template>
<script>
import { exportFile } from '@/api/downloadRequest'
export default {
  name: 'ProductViewList',
  data() {
    return {
      filterForm: {
        bankName: '',
        productName: '',
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      tableData: [],
    }
  },
  created() {
    this.getFinanceProductList()
  },
  methods: {
    /**
     * @description:
     * @Author: quwandong
     * @Date: 2023-10-27 08:47:21
     */
    formatProductType({ productType }) {
      return {
        2: '设备贷',
        3: '生资贷',
        4: '经营贷',
      }[productType]
    },
    //页码切换
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getFinanceProductList()
    },
    // 获取列表数据
    async getFinanceProductList() {
      try {
        let { data } = await this.$http.bank.getFinanceProductList({
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          ...this.filterForm,
        })
        this.tableData = data.content
        this.pagination.total = data.recordTotal
      } catch (error) {
        console.log(error)
      }
    },
    // 导出
    handleToExport() {
      this.$http.bank
        .financeProductExport({ ...this.filterForm, isOwner: 0 })
        .then((res) => {
          exportFile(res.data, '金融机构产品查询列表', 'xlsx')
        })
    },
    // 跳详情
    handleToDetail(row) {
      this.$router.push({
        path: '/product/view/detail',
        query: {
          id: row.id,
          businessOutlets: row.businessOutlets,
        },
      })
    },
    // 查询
    handleFilter() {
      this.pagination.currentPage = 1
      this.getFinanceProductList()
    },
    //重置
    handleReset(formName) {
      this.$refs[formName].resetFields()
      setTimeout(() => {
        this.handleFilter()
      }, 500)
    },
    // 银行机构
    bankAssociate(key, cb) {
      if (key !== '') {
        this.loading = true
        this.$http.bank
          .fuzzyQueryList({ key })
          .then(({ data }) => {
            this.loading = false
            let arr = data.map((item, index) => ({ name: item, value: index }))
            cb(arr) // 渲染回调
          })
          .catch((res) => {
            this.loading = false
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/common.scss';
.top-wrap {
  .title {
    display: flex;
    justify-content: space-between;
    .export {
      display: inline-block;
      width: 85px;
      height: 42px;
      text-align: center;
      line-height: 40px;
      background: #018388;
      color: #fff;
      border-radius: 5px;
      cursor: pointer;
    }
  }
}
.city-select {
  width: 160px;
}
</style>
